import Decimal from 'decimal.js';

export const convertPriceToCents = (price: number): number => {
    if (price === 0) return 0;
    return new Decimal(price).mul(100).toNumber();
};

export const convertPriceFromCents = (priceInCents: number): number => {
    if (priceInCents === 0) return 0;
    return new Decimal(priceInCents).div(100).toNumber();
};

export const validateNumericField = (
    value: number | undefined | null,
    { min, max, fieldName }: { min?: number; max?: number; fieldName: string }
): string | null => {
    if (value === undefined || value === null) return null;
    if (min !== undefined && value < min) return `${fieldName} must be at least ${min}`;
    if (max !== undefined && value > max) return `${fieldName} must be at most ${max}`;
    return null;
};

